module.exports = __webpack_public_path__ + "media/images/games/league-of-legends/square-bfd410bf9604ba8a448d27f2adc6d60f.jpg";